import { z } from 'zod';

export const DeleteClassroomSchema = z.object({
  classroomId: z.string(),
});

export type DeleteClassroomRequestDto = z.infer<typeof DeleteClassroomSchema>;

export type DeleteClassroomResponseDto = void;
